<template>
    <div>
        <p v-if="shouldShowNoAvailableFiltersText(filter)">{{ filter.noAvailableFiltersText }}</p>

        <cat-filter-value
            v-for="filterValue in mainFilterValues"
            :key="filterValue.value"
            :filter-value="filterValue"
            :has-selected-filter-value="hasSelectedFilterValue"
            @change="toggleCat(!filterValue.selected, filterValue.value)"
        />

        <template v-if="otherFilterValues.length">
            <v-btn
                class="my-2 px-1 font-weight-regular"
                color="rgba(0, 0, 0, 0.6)"
                :class="{ 'ml-8': hasSelectedFilterValue }"
                text
                @click="showAllFilterValues = !showAllFilterValues"
            >
                <span class="fl-all-filter-values">{{ $t(showAllFilterValues ? 'collapseSelect' : 'expandSelect') }}</span>
                <v-icon right>{{ showAllFilterValues ? mdiMinus : mdiPlus }}</v-icon>
            </v-btn>

            <v-expand-transition>
                <div v-if="showAllFilterValues">
                    <cat-filter-value
                        v-for="filterValue in otherFilterValues"
                        :key="filterValue.value"
                        :filter-value="filterValue"
                        :has-selected-filter-value="hasSelectedFilterValue"
                        @change="toggleCat(!filterValue.selected, filterValue.value)"
                    />
                </div>
            </v-expand-transition>
        </template>
    </div>
</template>
<script lang="ts">
import { Filter, FilterMetadata } from '../../../../../declarations/result';
import CatFilterValue from './CatFilter/CatFilterValue.vue';
import TextFilterMixin from './TextFilterMixin.vue';
import { Vue } from 'vue-property-decorator';

export default Vue.extend({
    name: 'CatFilter',
    components: { CatFilterValue },
    mixins: [TextFilterMixin],
    computed: {
        hasSelectedFilterValue(): boolean {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore TS does not recognize this value provided by the mixin, but WebStorm and the tests do. Fix later.
            return this.filter.values.some((filter: FilterMetadata) => filter.selected);
        },
        pinnedFilterValueCount(): number {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore TS does not recognize this value provided by the mixin, but WebStorm and the tests do. Fix later.
            const filter = this.filter as Filter;

            return this.hasSelectedFilterValue ? (filter.pinnedFilterValueCount || 0) + 1 : filter.pinnedFilterValueCount;
        },
        mainFilterValues(): FilterMetadata[] {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore TS does not recognize this value provided by the mixin, but WebStorm and the tests do. Fix later.
            const filter = this.filter as Filter;

            return this.pinnedFilterValueCount < filter.values.length ? filter.values.slice(0, this.pinnedFilterValueCount) : filter.values;
        },
        otherFilterValues(): FilterMetadata[] {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore TS does not recognize this value provided by the mixin, but WebStorm and the tests do. Fix later.
            const filter = this.filter as Filter;

            return this.pinnedFilterValueCount < filter.values.length ? filter.values.slice(this.pinnedFilterValueCount) : [];
        },
    },
    methods: {
        toggleCat(selected: boolean, cat: string): void {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore TS does not recognize this value provided by the mixin, but WebStorm and the tests do. Fix later.
            this.selectedFilterValues = selected ? [cat] : [];
        },
    },
});
</script>

<style lang="scss" scoped>
.fl-all-filter-values {
    letter-spacing: normal;
    text-transform: none;
}
</style>
